import "../css/style.scss";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

export default function LoadingScreen() {
  const [loaded, setLoaded] = useState(false);

  window.onload = () => {
    setLoaded(true);
  };
  // in case onload doesn't fire, set a timeout
  setTimeout(() => {
    setLoaded(true);
  }, 3000);

  return (
    <div className="loading-screen" style={{ top: loaded ? "-100%" : "0" }}>
      <div className="content" style={{ opacity: loaded ? "0" : "1" }}>
        <FontAwesomeIcon className="icon" icon={faPlus} spin />
        <FontAwesomeIcon className="icon" icon={faPlus} spin />
        <FontAwesomeIcon className="icon" icon={faPlus} spin />
      </div>
    </div>
  );
}
